module.exports = __webpack_public_path__ + "img/94.20c2c8c5.jpg";